import {API} from "aws-amplify";

class TrackingAPI {
  postSession = async (accountId: string, userId: string, sessionDate: string, duration: number) : Promise<any> => {
    const init = {
      body: {
        accountId,
        userId,
        sessionDate,
        duration
      }
    }
    const response = await API.post("TrackingAPI", "/session", init)
    return response
  }
}

export default TrackingAPI